exports.f = {}.propertyIsEnumerable;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_object-pie.js
 ** module id = 93
 ** module chunks = 0
 **/